<template>
    <div id="thoughtquestion">
        <div v-if="error" class="error">Please enter a response before clicking Submit.</div>
        <div class="ui form"><div class="fields"><textarea class="ui" id="responseBox" cols="60" rows="5" v-model="responseText" placeholder="Please enter your response here."></textarea></div></div>
        <button id="submitButton" class="ui button primary" @click="submitClick">Submit</button>
        <button @click="viewClick" class="ui right floated basic button primary viewmore" v-if="!boosterData.private">View Answers</button>
    </div>
</template>
<script>
export default {
    name: 'ThoughtQuestion',
    props: [ 'boosterData', 'api', 'boosterId', 'learnerId', 'programId' ],
    data() {
        return {
            responseText: '',
            error: false
        }
    },
    methods: {
        viewClick: function() {
            window.location = '/booster/tq/view/'+(this.boosterData.bid-1)+'/1/view'
        },
        submitClick: async function() {
            if(this.responseText == '') {
                this.error = true;
            }
            else {

                if (this.api) {

                    await this.api.post('/api/event', {
                        code: 303,
                        lid: this.learnerId,
                        pid: this.programId,
                        bid: this.boosterId ,
                        submission: this.responseText,
                    }, {
                        headers: {
                            'Set-Cookie': 'lid='+this.learnerId+'; Secure; HttpOnly;'
                        }
                    })

                    if (this.boosterData.private) {
                        window.location = '/booster/tq/private/'+this.boosterData.bid
                    }
                    else {
                        window.location = '/booster/tq/view/'+(this.boosterData.bid-1)+'/1/view'
                    }
                }
            }
        }
    }
}
</script>
<style scoped>
#thoughtquestion {
    pointer-events: none;
}
.button {
    pointer-events: auto;
}
textarea {
    width: 100%;
    height: auto;
    margin-bottom: 15px !important;
    pointer-events: auto;
}
.error {
    color: #F00;
    margin: 15px;
}
@media (max-width: 640px) {
    .viewmore {
        max-width: 150px !important;
    }
}
</style>